if (document.body.classList.contains('cc-animate-enabled')) {
  if ('IntersectionObserver' in window && 'MutationObserver' in window) {
    const aosMinWidth = getComputedStyle(document.documentElement).getPropertyValue('--aos-min-width').trim() || '0';
    const mq = window.matchMedia(`(min-width: ${aosMinWidth}px)`);
    const pendingElements = new Set();
    let intersectionObserver;
    let mutationObserver;

    const initAnimateOnScroll = () => {
      if (!mq.matches || !intersectionObserver) return;
      pendingElements.forEach((elem) => {
        if (!elem.isConnected) {
          intersectionObserver.unobserve(elem);
          pendingElements.delete(elem);
          elem.classList.remove('cc-animate-init');
        }
      });
      document.querySelectorAll('[data-cc-animate]:not(.cc-animate-init)').forEach((elem) => {
        if (elem.dataset.ccAnimateDelay) elem.style.animationDelay = elem.dataset.ccAnimateDelay;
        if (elem.dataset.ccAnimateDuration) elem.style.animationDuration = elem.dataset.ccAnimateDuration;
        if (elem.dataset.ccAnimate) elem.classList.add(elem.dataset.ccAnimate);
        elem.classList.add('cc-animate-init');
        pendingElements.add(elem);
        intersectionObserver.observe(elem);
      });
    };

    const observeMutations = () => {
      if (!mq.matches || !intersectionObserver || mutationObserver) return;
      mutationObserver = new MutationObserver(debounce(initAnimateOnScroll, 250));
      mutationObserver.observe(document.body, { subtree: true, childList: true });
    };

    const updateAnimations = () => {
      if (mq.matches) {
        if (intersectionObserver) return;
        document.body.classList.add('cc-animate-enabled');
        intersectionObserver = new IntersectionObserver((entries, observer) => {
          if (!mq.matches) return;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('cc-animate-in');
              observer.unobserve(entry.target);
              pendingElements.delete(entry.target);
            }
          });
        });
        initAnimateOnScroll();
        if (document.readyState !== 'loading') observeMutations();
      } else {
        document.body.classList.remove('cc-animate-enabled');
        if (intersectionObserver) intersectionObserver.disconnect();
        if (mutationObserver) mutationObserver.disconnect();
        intersectionObserver = undefined;
        mutationObserver = undefined;
        pendingElements.forEach((elem) => elem.classList.remove('cc-animate-init'));
        pendingElements.clear();
      }
    };

    document.addEventListener('DOMContentLoaded', observeMutations, { once: true });
    try {
      mq.addEventListener('change', updateAnimations);
    } catch (e) {
      mq.addListener(updateAnimations);
    }
    updateAnimations();
  } else {
    document.body.classList.remove('cc-animate-enabled');
  }
}
